import React, { Component } from 'react';
import './Header.scss';
import HomePageImageQuery from '../../Image/HomePageImageQuery'
import { Image } from '../../Image';
import GatsbyLink from '../../GatsbyLink'
import Carousel from '../../Carousel';
import { Breadcrumbs } from '../../Breadcrumbs'
import { decodeEntities } from '../../../utils/helpers';

class HeaderSlider extends Component {
  render () {
    const { slider, globalTitle, location, containImage } = this.props;
    const settings = {
      container: 'page-carousel',
      nav: true,
      mouseDrag: true,
      items: 1,
      controls:true,
      rewind: true,
      loop:false,
      mode: 'gallery',
      autoplay: globalTitle ? true : false
    };
    return (
      <div className="page-slider">
        {slider.length ?
        <Carousel settings={settings}>
          {slider.map((slide, slide_count) => (
            <div key={slide_count} className="slide">
              {slide.background && (slide.background.url || slide.background.source_url) &&
                <div className={`background-wrap${containImage ? ' contain' : ' no-contain'}`}>
                  <div className="background">
                    <div className="inner">
                      {location.pathname === "/" && slide_count == 0 ? <HomePageImageQuery /> : <Image src={slide.background} /> }
                      {containImage && <div className="image-title" dangerouslySetInnerHTML={{ __html: decodeEntities(slide.background.title) }} />}
                    </div>
                  </div>
                </div>
              }
              {!globalTitle &&
                <div className={`title-block${slide.background && (slide.background.url || slide.background.source_url) ? ' image' : ' no-image'}`}>
                  <div className="wrap">
                    <div className="inner">
                      {location && location.pathname !== "/" && <Breadcrumbs location={location}/>}
                      {slide_count == 0 ? <h1 className="title" dangerouslySetInnerHTML={{ __html: decodeEntities(slide.header) }} /> : <h2 className="title" dangerouslySetInnerHTML={{ __html: decodeEntities(slide.header) }} />}
                      {slide.subHeader && <span className="sub-title" dangerouslySetInnerHTML={{ __html: decodeEntities(slide.subHeader) }} />}
                      {slide.shortDescription && <span className="short-description">{slide.shortDescription}</span>}
                      {slide.action && <GatsbyLink to={slide.action.url} className="action" decode={true}>{slide.action.title}</GatsbyLink>}
                      {/* {slide.actionTwo && <GatsbyLink to={slide.actionTwo.url} className="action" decode={true}>{slide.actionTwo.title}</GatsbyLink>} */}
                    </div>
                  </div>
                </div>
              }
            </div>
          ))}
        </Carousel>
        :
          <div className="slide"/>
        }
      </div>
    )
  }
}

export const Header = (props) => {
  const {
    compact,
    globalTitle,
    header,
    subHeader,
    shortDescription,
    containImage,
    location = null
  } = props
  return (
    <section className={`page-header${compact ? ' compact' : ''}`}>
      <HeaderSlider {...props} />
      {globalTitle &&
        <div className={`title-block`}>
          <div className="wrap">
            <div className="inner">
              {location && <Breadcrumbs location={location}/>}
              <h1 className="title" dangerouslySetInnerHTML={{ __html: decodeEntities(header) }} />
              {subHeader && <span className="sub-title" dangerouslySetInnerHTML={{ __html: decodeEntities(subHeader) }} />}
              {shortDescription && <span className="short-description">{shortDescription}</span>}
            </div>
          </div>
        </div>
      }
    </section>
  )
}

export default Header
